import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-perio-cheat-sheet-key',
  imports: [CommonModule],
  templateUrl: './perio-cheat-sheet-key.component.html',
  styleUrl: './perio-cheat-sheet-key.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioCheatSheetKeyComponent {
  public readonly disabled = input(false);
}
